import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  BrokerDeltaExchangeProfile,
  BrokerProfile,
  BinanceProfile,
  BrokerBinanceOpenPositiondata,
  ZebpayProfile,
  BrokerCoinswitchWallet,
  BrokerPi42tradingon,
  BrokerPi42wallet,
} from "../../../Service/Broker.service";

export const BrokerProfile_Info = createAsyncThunk(
  "BrokerProfile",
  async (data) => {
    try {
      const res = await BrokerProfile(data);
      return await res;
    } catch (err) {
      return err;
    }
  }
);

export const DeltaBrokerProfile_Info = createAsyncThunk(
  "brokerDeltaProfile_info",
  async (data) => {
    try {
      const res = await BrokerDeltaExchangeProfile(data);
      return await res;
    } catch (err) {
      return err;
    }
  }
);

export const BinanceBrokerProfile_Info = createAsyncThunk(
  "brokerBinanceProfileInfo",
  async (data) => {
    try {
      const res = await BinanceProfile(data);
      return await res;
    } catch (err) {
      return err;
    }
  }
);

export const BrokerBinanceOpenPosition = createAsyncThunk(
  "BrokerBinanceOpenPositiondata",
  async (data) => {
    try {
      const res = await BrokerBinanceOpenPositiondata(data);
      return await res;
    } catch (err) {
      return err;
    }
  }
);

export const ZebPayBrokerProfile_Info = createAsyncThunk(
  "brokerZebPayProfileInfo",
  async (data) => {
    try {
      const res = await ZebpayProfile(data);
      return await res;
    } catch (err) {
      return err;
    }
  }
);

export const Broker_Coinswitch_Wallet = createAsyncThunk(
  "brokerCoinswitchWallet",
  async (data) => {
    try {
      const res = await BrokerCoinswitchWallet(data);
      return await res;
    } catch (err) {
      return err;
    }
  }
);

export const BrokerPi42wallet_API = createAsyncThunk(
  "pi42/tradingon",
  async (data) => {
    try {
      const res = await BrokerPi42tradingon(data);
      return await res;
    } catch (err) {
      return err;
    }
  }
);

export const BrokerPi42_API = createAsyncThunk("pi42/wallet", async (data) => {
  try {
    const res = await BrokerPi42wallet(data);
    return await res;
  } catch (err) {
    return err;
  }
});

const Brokerdata = createSlice({
  name: "AuthSlice",
  initialState: {
    isLoading: false,
    isError: false,
    BrokerProfile_Info: [],
    DeltaBrokerProfile_Info: [],
    BinanceBrokerProfile_Info: [],
    BrokerBinanceOpenPosition: [],
    logdatails: {},
    ZebPayBrokerProfile_Info: [],
    Broker_Coinswitch_Wallet: [],
  },

  recuders: {},
  extraReducers: {
    [BrokerProfile_Info.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      return { ...state, logdatails: payload };
    },
    [DeltaBrokerProfile_Info.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      return { ...state, logdatails: payload };
    },
    [BinanceBrokerProfile_Info.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      return { ...state, logdatails: payload };
    },
    [BrokerBinanceOpenPosition.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      return { ...state, logdatails: payload };
    },
    [Broker_Coinswitch_Wallet.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      return { ...state, logdatails: payload };
    },
    [BrokerPi42wallet_API.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      return { ...state, logdatails: payload };
    },
    [BrokerPi42_API.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      return { ...state, logdatails: payload };
    },
  },
});

export default Brokerdata;
